package br.com.texeratx.boardgametimeapp.data.model.dashboard

import kotlinx.serialization.Serializable

@Serializable
data class DashboardResponse(
    val topPlayers: List<DashboardPlayerDTO>,
    val topGames: List<DashboardGameDTO>,
    val lastMatches: List<LastMatchesDTO>,
    val currentMonthMatches: Int,
    val currentMonthMinutes: Int
)